import { render, staticRenderFns } from "./_OtherInfo.vue?vue&type=template&id=7c17615c"
import script from "./_OtherInfo.vue?vue&type=script&lang=js"
export * from "./_OtherInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports